export default {"src":"/_next/static/media/superscript_logo.6e7de22f.svg","height":70,"width":255,"blurWidth":0,"blurHeight":0};